import { NotificationIconType } from '@nutanix-ui/prism-reactjs/lib/components/v2/Notification/NotificationIcons';

import { NotificationSeverity } from '../../NotificationsWidget/queries';

export function getToastType(severity?: NotificationSeverity): NotificationIconType {
  switch (severity) {
    case NotificationSeverity.WARNING:
      return NotificationIconType.WARNING;
    case NotificationSeverity.ERROR:
      return NotificationIconType.ERROR;
    case NotificationSeverity.INFO:
    default:
      return NotificationIconType.SUCCESS;
  }
}

export const DEFAULT_AUTO_DISMISS_DELAY_SECS = 10;
export const DEFAULT_TOAST_WIDTH = 400;
export const DEFAULT_TOAST_LINE_COUNT = 3;
